import { Component, OnInit } from '@angular/core';
import { NavParams, PopoverController } from '@ionic/angular';

@Component({
  selector: 'reservationstatus-popover',
  templateUrl: 'cityAddressPopup.html',
  styleUrls: ['cityAddressPopup.scss'],

})

export class cityAddressPopup implements OnInit {

 
  public cityData: any;
  public cityAddressDataCopy: any;
  


  constructor(public navParams: NavParams, private popoverController: PopoverController) {
  }

  ngOnInit() {

    this.cityData = this.navParams.data.cityData;
    this.cityAddressDataCopy = this.navParams.data.cityData;
    
  }

  searchCity(search) {
    const term = (search || "").toString().toLowerCase().trim();
    this.cityData = this.cityAddressDataCopy;
    if (!term) {
      return;
    }

    this.cityData = this.cityData.filter(item => {
      return item.cityName.toLowerCase().includes(term);
    });
  }

  addToCartClicked(city) {
    this.popoverController.dismiss(city);
  }

}

